import React, { FC, useCallback } from 'react'
import { Grid } from '@mui/material'
import { useDispatch } from 'react-redux'
import { FormProvider, useForm } from 'react-hook-form'
import { CreateClientTypeRequestDto } from '@sparling/financial-common/dist'
import { classValidatorResolver } from '@hookform/resolvers/class-validator'
import { Modal } from '../../../../../components/Modal'
import { InputField } from '../../../../../components/InputField'
import { createClientTypeRequest } from '../../../../../store/actions'

interface ClientTypeCreateModalProps {
  isOpen: boolean
  modalClose: () => void
}

export const ClientTypeCreateModal: FC<ClientTypeCreateModalProps> = ({ isOpen, modalClose }) => {
  const dispatch = useDispatch()

  const formMethods = useForm<CreateClientTypeRequestDto>({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: classValidatorResolver(CreateClientTypeRequestDto),
  })

  const {
    handleSubmit,
    formState: { isValid },
    reset,
  } = formMethods

  const onSubmit = useCallback(
    (data) => {
      dispatch(createClientTypeRequest(data))
      reset()
      modalClose()
    },
    [dispatch, modalClose, reset],
  )

  return (
    <Modal
      title={'Create Client Type'}
      submitTitle="Create"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
      isWidthAuto
    >
      <FormProvider {...formMethods}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <InputField inputName={'name'} inputType={'text'} labelName={'Name'} fullWidth />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
